import { createContext, useContext, useState } from "react";
import { http } from "@/lib/api";

const AdminContext = createContext(null);
export const useAdmin = () => useContext(AdminContext);

export const AdminProvider = ({ children }) => {
  const [token, setToken] = useState(() => localStorage.getItem("bc_admin_token"));

  const login = async (email, password) => {
    const { data } = await http.post("/admin/login", { email, password });
    localStorage.setItem("bc_admin_token", data.token);
    setToken(data.token);
    return data;
  };

  const logout = () => {
    localStorage.removeItem("bc_admin_token");
    setToken(null);
  };

  return (
    <AdminContext.Provider value={{ token, isAdmin: !!token, login, logout }}>
      {children}
    </AdminContext.Provider>
  );
};
